import { render, staticRenderFns } from "./blogs.vue?vue&type=template&id=71ac39f1&scoped=true&"
import script from "./blogs.vue?vue&type=script&lang=js&"
export * from "./blogs.vue?vue&type=script&lang=js&"
import style0 from "./blogs.vue?vue&type=style&index=0&id=71ac39f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac39f1",
  null
  
)

export default component.exports